import { all, takeLatest } from 'redux-saga/effects';
import { EDIT_TEACHER_REQUEST, onHandleEditTeacherProfileRequest, onHandleTeacherProfileRequest, TEACHER_PROFILE_REQUEST } from './redux';

function * watchTeacherProfile () {
  console.log('#watchTeacherProfile');
  yield takeLatest(TEACHER_PROFILE_REQUEST, onHandleTeacherProfileRequest);
}

function * watchEditTeacher () {
  console.log('#watchEditTeacher');
  yield takeLatest(EDIT_TEACHER_REQUEST, onHandleEditTeacherProfileRequest);
}

export default function * sagas () {
  yield all([
    watchTeacherProfile(),
    watchEditTeacher()
  ]);
}
